import { render, staticRenderFns } from "./BannedURL.vue?vue&type=template&id=59236b1a&lang=html&"
import script from "./BannedURL.vue?vue&type=script&lang=js&"
export * from "./BannedURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports